import React, { useEffect } from 'react';

import giant1 from './../Images/thegianthunt1.jpg';
import giant2 from './../Images/thegianthunt2.jpg';
import giant3 from './../Images/thegianthunt3.jpg';

export default function Popup({ onClose }) {
    useEffect(() => {
        document.body.classList.add("fix");

        return () => {
            document.body.classList.remove("fix");
        };
    }, []);
    return (
        <div className="popup-cont" style={{ display: 'block' }}>
            <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                    <tr>
                        <td><div className="pop-cont"> <a className="pop-close" onClick={onClose}></a>
                            <div className="pop-inn-cont">
                                <a href="https://thegianthunt.com/Index.aspx" target="_blank" className="d-blk">
                                    <img src={giant1} className="pop-img1" alt="World's Largest Anime Art Competition | The Giant Hunt" width="950" height="560" />
                                    <img src={giant2} className="pop-img2" alt="World's Largest Anime Art Competition | The Giant Hunt" width="950" height="475" />
                                    <img src={giant3} className="pop-img3" alt="World's Largest Anime Art Competition | The Giant Hunt" width="950" height="1267" />
                                </a>
                            </div>
                        </div></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
